import { memo } from 'react'

import styles from './ra-grid.module.scss'

interface RaGridProps {
  children: React.ReactNode
  columns?: number
  gap?: number
  columnGap?: number
  rowGap?: number
}

export const RaGrid = memo(({ children, columns = 12, gap = 24 }: RaGridProps) => {
  return (
    <div
      style={
        {
          '--ra-grid-columns': columns,
          '--ra-grid-gap': `${gap}px`,
        } as React.CSSProperties
      }
      className={styles['ra-grid']}>
      {children}
    </div>
  )
})

RaGrid.displayName = 'RaGrid'
